const $ = require('jquery'), scrollSize = require('scrollbar-size');

module.exports = function ($timeout) {
    return {
        restrict: 'A',
        require: 'wowHideScroll',
        controller: [
            '$element', '$attrs', function ($element, $attrs) {
                // Get our jquery objects
                const $window = $(window);

                const $scrollRail = $('<div class="wowScrollbar"><div class="wowScrollbar-indicator"></div></div>');
                const $scrollIndicator = $scrollRail.children('.wowScrollbar-indicator');
                const $scrollArea = $element.children('.hideScroll-wrapper').first();
                let scrollingEnabled = false, timeoutPromise = null, visibleHeight, indicatorHeight, maxScrollTop;

                const hasScrollbar = scrollSize() > 0,
                    // The minimum indicator width can be overridden. This is used for the visual
                    // shopping scroller but SHOULD NOT be used otherwise.
                    minIndicatorWidth = parseInt($attrs.wowScrollbar) || 10;

                function getIndicatorPosition(scrollTop) {
                    return scrollTop / maxScrollTop * (visibleHeight - indicatorHeight);
                }

                function getScrollTop(indicatorPosition) {
                    return (maxScrollTop * indicatorPosition) / (visibleHeight - indicatorHeight);
                }

                function translateToRelative(yCoord, element) {
                    element = element || $scrollRail;

                    return yCoord - element.offset().top;
                }

                function isClickInsideScrollIndicator(clickY) {
                    const scrollIndicatorTop = $scrollIndicator.offset().top;
                    const scrollIndicatorBottom = scrollIndicatorTop + indicatorHeight;
                    return clickY >= scrollIndicatorTop && clickY <= scrollIndicatorBottom;
                }

                function scrollToIndicatorPosition(indicatorPosition) {
                    return $scrollArea.scrollTop(getScrollTop(indicatorPosition));
                }

                function recalculateSizes() {
                    // Get the heights we're concerned with.
                    const contentHeight = $scrollArea[0].scrollHeight;
                    visibleHeight = $element.height();

                    // Set the indicator's height proportianally.
                    indicatorHeight = Math.max(minIndicatorWidth, (visibleHeight / contentHeight) * visibleHeight);
                    $scrollIndicator.css('height', indicatorHeight);

                    maxScrollTop = contentHeight - visibleHeight;

                    $scrollRail.toggleClass('is-notScrollable', visibleHeight === indicatorHeight);
                }

                function onRailMousedown(mousedownEvent) {
                    mousedownEvent.preventDefault();

                    const origClickY = mousedownEvent.pageY;
                    let origScrollIndicatorTop = $scrollIndicator.position().top;

                    if (!isClickInsideScrollIndicator(mousedownEvent.pageY)) {
                        origScrollIndicatorTop = translateToRelative(mousedownEvent.pageY) - (0.1 * indicatorHeight);
                        scrollToIndicatorPosition(origScrollIndicatorTop);
                    }

                    $window.on('mousemove.scrollbar', (mousemoveEvent) => {
                        mousemoveEvent.preventDefault();

                        requestAnimationFrame(() => {
                            const mouseDeltaY = (origClickY - mousemoveEvent.pageY);
                            const newIndicatorPosition = origScrollIndicatorTop - mouseDeltaY;
                            scrollToIndicatorPosition(newIndicatorPosition);
                        });
                    });

                    $window.on('mouseup', () => {
                        $window.off('mousemove.scrollbar');
                    });
                }

                function onScrollAreaSroll() {
                    requestAnimationFrame(() => {
                        // Cancel the timeout if we scroll before it completes
                        if (timeoutPromise) {
                            $timeout.cancel(timeoutPromise);
                        }
                        const scrollTop = $scrollArea.scrollTop();

                        // The indicator position is the proportion of scrollability multiplied by the space that is available to scroll within.
                        const indicatorPosition = getIndicatorPosition(scrollTop);

                        // Set the position
                        $scrollIndicator.css('top', `${indicatorPosition}px`);

                        // Show the indicator
                        $scrollRail.addClass('is-active');
                        $element.toggleClass('is-scrolled', scrollTop > 0);

                        // Set a timeout to hide the indicator
                        timeoutPromise = $timeout(() => {
                            $scrollRail.removeClass('is-active');
                        }, 1200, false);
                    });
                }

                this.enableScrolling = function () {
                    if (hasScrollbar && !scrollingEnabled) {
                        scrollingEnabled = true;

                        $element.append($scrollRail);

                        recalculateSizes();

                        $scrollArea.on('scroll.scrollbar', onScrollAreaSroll);
                        $scrollRail.on('mousedown.scrollbar', onRailMousedown);

                        $scrollArea.on('scrollstart.scrollbar', recalculateSizes);
                        $scrollRail.on('mouseenter.scrollbar', recalculateSizes);

                        $scrollArea.on('mouseenter.scrollbar', recalculateSizes);
                    }
                };

                this.disableScrolling = function () {
                    if (hasScrollbar && scrollingEnabled) {
                        scrollingEnabled = false;

                        $scrollRail.detach();

                        $scrollArea.off('scroll.scrollbar');
                        $scrollRail.off('mousedown.scrollbar');

                        $scrollArea.off('scrollstart.scrollbar');
                        $scrollRail.off('mouseenter.scrollbar');

                        $scrollArea.off('mouseenter.scrollbar');
                    }
                };

                if (!hasScrollbar || $scrollArea.length <= 0) {
                    // we are most likely on a mobile device
                    $scrollArea.on('scroll', () => {
                        requestAnimationFrame(() => {
                            const scrollTop = $scrollArea.scrollTop();
                            // Let the element style itself when it's scrolled
                            $element.toggleClass('is-scrolled', scrollTop > 0);
                        });
                    });
                } else {
                    this.enableScrolling();
                }
            },
        ],
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/scrollbar/scrollbar.directive.js